/**
 * Struct definition management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class StructDefManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async listAll(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/cdp_struct_def/listAll', { params });
  }
}
